import React, { useMemo } from "react";
import { Layers } from "lucide-react";
import MasterDataCrudPage from "./MasterDataCrudPage";
import apiService from "../../services/api";

const BusinessLineManagement = () => {
  const api = useMemo(
    () => ({
      list: (params) => apiService.businessLines.list(params),
      create: (data) => apiService.businessLines.create(data),
      update: (id, data) => apiService.businessLines.update(id, data),
      delete: (id) => apiService.businessLines.delete(id),
    }),
    [],
  );

  return (
    <MasterDataCrudPage
      title="业务线"
      subtitle="维护业务线主数据；新建账号配置时需选择已启用的业务线。"
      singularName="业务线"
      api={api}
      TitleIcon={Layers}
    />
  );
};

export default BusinessLineManagement;
